import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import CustomViewButton from "../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Media Folder",
  "Actions",
];


const AllFolderTable = ({ mediaData = [], currentPage= 0, itemsPerPage= 50 }) => {
  const navigate = useNavigate();
  const location = useLocation();

  
 
  const goToView = (subfolder) => {
    // navigate(`/farmMedia/farmTrainingMedia/subfolder/${item}`);
    navigate(`/view-perFolder-farmTraining-media/${subfolder}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
            <tr>
              {tableHead?.map((item, index) => {
                return <th key={index}>{item}</th>;
              })}
            </tr>
        </thead>
        <tbody>
        {mediaData.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item|| "N/A"}</td>
                <td>
                  <CustomViewButton  onClick={() => goToView(item)}></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AllFolderTable;
